import { type ReactNode } from 'react';

import { Icons } from '@/assets/icons/icons';
import { cn } from '@/lib/utils';

export const SHIMMER_TEXT_CLASSES = [
  'bg-[linear-gradient(to_right,var(--reasoning-accent)_0%,var(--reasoning-accent)_45%,var(--reasoning-accent-highlight)_50%,var(--reasoning-accent)_55%,var(--reasoning-accent)_100%)]',
  'bg-[length:200%_100%]',
  '[background-position:0%_0]',
  'animate-shimmer-working',
  'motion-reduce:animate-none',
] as const;

export const ShimmerCollapsibleHeader = ({
  title,
  isShimmering,
  open,
  onOpenChange,
  showChevron = true,
  'data-testid': dataTestId,
}: {
  title: ReactNode;
  isShimmering: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  showChevron?: boolean;
  'data-testid'?: string;
}) => {
  const isInteractive = showChevron;
  const titleContent = (
    <>
      <span
        className={cn(
          'text-sm',
          isShimmering
            ? ['bg-clip-text text-transparent', ...SHIMMER_TEXT_CLASSES]
            : 'text-[var(--reasoning-accent)]'
        )}
      >
        {title}
      </span>
      {showChevron && (
        <Icons.chevronRight
          className={cn(
            'size-3 text-foreground-subtle transition-transform',
            open && 'rotate-90'
          )}
        />
      )}
    </>
  );

  if (!isInteractive) {
    return (
      <div
        data-testid={dataTestId}
        className="flex w-full items-center gap-1 px-1 select-none"
      >
        {titleContent}
      </div>
    );
  }

  return (
    <button
      type="button"
      data-testid={dataTestId}
      className={cn(
        'group flex w-full items-center gap-1 px-1 select-none rounded text-left',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-strong cursor-pointer'
      )}
      onClick={() => onOpenChange(!open)}
      aria-expanded={open}
    >
      {titleContent}
    </button>
  );
};
